// seen - but not optimized

import { Link } from "react-router-dom";


const NoRouteMatch = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center">
      <div className="max-w-md mx-auto px-4 text-center">
        <h1 className="text-3xl font-bold text-gray-700 mb-4">Oops! Page Not Found</h1>
        <p className="text-sm text-gray-600 mb-8">The page you are looking for does not exist.</p>
        
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-full mb-12 text-gray-700">
        <path strokeLinecap="round" stroke-linejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
        <path strokeLinecap="round" stroke-linejoin="round" strokeWidth="2" d="M21 21l-9-9m0 0l-9 9m9-9V3"/>
        </svg>

        <Link className="bg-red-600 hover:bg-red-600 text-white mt-12 font-bold py-3 px-12 rounded-3xl focus:outline-none focus:shadow-outline" to='/'>
          Go Back Home
        </Link>
      </div>
    </div>
  );
};

export default NoRouteMatch;